<template>
  <section>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Background Color</span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <color-picker
            :color="assetForm.bgcolor"
            :sucker-hide="true"
            :sucker-canvas="suckerCanvas"
            :sucker-area="suckerArea"
            @changeColor="changeBGColor"
          />

          <!-- <vs-input
            class="w-full"
            placeholder="eg : #111"
            v-model="assetForm.bgcolor"
          /> -->
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Background Image</span>
          <div style="font-size:0.75rem; color:#aaa;">
            Recommended size: 1500x1800px. File size must be less than 1 mb.
          </div>
        </div>
        <div class="vx-col sm:w-1/3 w-full">
			<div v-if="event.bgimg != null">
            <!-- <vs-button
              size="small"
              style="position:absolute; top:0; right:0;"
              @click="removeAsset('background')"
              >Remove</vs-button
            > -->
            <!-- {{ event.bgimg }} -->
				<img
				:src="event.bgimg"
				:width="imageWidth"
				:height="imageHeight"
				/>
			</div>
			<div
				v-if="!event.bgimg"
				class="default-upload"
				style="width: 300px; height: 158px; background-color: #F5F5F5; border-radius: 8px; position: relative;" 
			>
				<vs-button
					style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"
					color="dark"
					type="border"
					@click="chooseImage()"
				>
					<span>Upload</span>
				</vs-button>
				<input
					id="file-upload-img"
					@change="onUploadImages()"
					type="file"
					ref="fileImage"
					:accept="acceptFile"
				>

			</div>
			<div
				v-if="event.bgimg"
				class="grid-button-upload"
				style="margin-top: 8px; display: grid; grid-template-columns: repeat(2, min-content);grid-gap: 10px;"
			>
				<vs-button
				color="dark"
				type="flat"
				icon="autorenew"
				style="display: flex"
				@click="chooseImage()"
				>
					Change
				</vs-button>
				<input
					id="file-upload-img"
					@change="onUploadImages()"
					type="file"
					ref="fileImage"
					:accept="acceptFile"
				>
				<vs-button
				color="dark"
				type="flat"
				icon="delete_forever"
				style="display: flex"
				@click="popupActivo=true"
				>
					Remove
				</vs-button>
        <vs-popup
            classContent="popup-confirm"
            title="Confirm Delete"
            :active.sync="popupActivo"
          >
            <div>Are you sure you want to delete the image?</div>
            <div class="wrap-button">
              <vs-button
                color="dark"
                type="border"
                style="font-size: 12px !important;"
                @click="popupActivo=false"
              >
                No
              </vs-button>
              <vs-button
                color="primary"
                style="font-size: 12px !important;"
                @click="removeAsset('background')"
              >
                Yes
              </vs-button>
            </div>
          </vs-popup>
			</div>
          <!-- <vs-upload
            v-if="!event.bgimg || changeImage"
            :multiple="false"
            :automatic="true"
            :single-upload="true"
            :show-upload-button="false"
            :action="posterUploadUrl"
            :fileName="`file`"
            :limit="1"
            :data="bgImgData"
            :headers="posterUploadHeader"
            @on-success="successPosterUpload"
            @on-error="errorPosterUpload"
            accept="image/png, image/jpeg, image/jpg, image/webp"
          /> -->
          <!-- <div
            class="grid-button-upload"
            v-if="event.bgimg || showBtn"
          >
            <vs-button
              color="dark"
              type="flat"
              icon="autorenew"
              style="display: flex"
              @click="changeBgImg()"
            >
              Change
            </vs-button>
            <vs-button
              color="dark"
              type="flat"
              icon="delete_forever"
              style="display: flex"
              @click="removeAsset('background')"
            >
              Remove
            </vs-button>
          </div> -->
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Text Color</span>
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <color-picker
            :color="assetForm.txtcolor"
            :sucker-hide="true"
            :sucker-canvas="suckerCanvas"
            :sucker-area="suckerArea"
            @changeColor="changeTextColor"
          />
          <!-- <vs-input
            class="w-full"
            placeholder="eg : #111"
            v-model="assetForm.txtcolor"
          /> -->
        </div>
      </div>

      <div class="vx-row mb-6" v-if="role == 'so-admin'">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Font</span>
        </div>
        <!-- <div class="vx-col sm:w-1/3 w-full">
          <vs-input
            class="w-full"
            placeholder="Google Font"
            v-model="assetForm.font"
          />
        </div> -->
        <vs-select
          autocomplete
          @input-change="autoCompleteFunc"
          class="vx-col sm:w-1/3 w-full"
          v-model="assetForm.font"
          placeholder="Google Font"
          >
            <vs-select-item :key="index" :value="item.family" :text="item.family" v-for="(item,index) in fontList" />
        </vs-select>

      </div>

    <vs-divider></vs-divider>
    <div class="vx-row pt-2 mt-0">
      <div class="vx-col w-full ml-auto">
        <vs-button class="mr-3 mb-2" @click="submitAsset">Save </vs-button>

        <vs-button class="mr-3 mb-2" type="border" @click="canceled">Cancel </vs-button>
      </div>
    </div>
  </section>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";
import Service from "@/services";

import { currencyList, protypeList } from "@/utils/Constants";
import { timezones } from "@/utils/Timezones";
import { eventFieldsPermission } from "@/utils/FieldsPermission";

import { assetForm, basicForm } from "@/utils/eventForm";

import colorPicker from "@caohenghu/vue-colorpicker";

export default {
  components: {
    colorPicker
  },
  props: {
    event: null,
    role: null,
    assetForm: assetForm,
    folder: null,
    basicForm: basicForm
  },
  data() {
    return {
      colorpickerDialog: true,
      posterUploadUrl:
        process.env.VUE_APP_API_URL + "/events/" + this.folder + "/upload",
      posterUploadHeader: {
        Authorization:
          "Bearer " +
          JSON.parse(localStorage.getItem("soldoutt-nimda")).Auth.accessToken
      },
      bgImgData: {
        type: "bgimg"
      },
		suckerCanvas: null,
		suckerArea: [],
		isSucking: false,
		fontList: [],
		imageWidth: 0,
		imageHeight: 0,
		changeImage: false,
		showBtn: false,
		bgUpdate: null,
		acceptFile: [
			'image/png',
			'image/jpeg',
			'image/jpg',
			'image/webp',
		],
    popupActivo: false
    };
  },
  methods: {
    changeImagePoster() {
      this.changeImage = true
    },
    removeposter() {
      this.event.bgimg = null
    },
    setImageSize () {
      let posterimage = document.querySelector('img')
      let w = posterimage.naturalWidth;
      let h = posterimage.naturalHeight;
      this.imageHeight = h
      this.imageWidth = w
    
      if (w > h) {
        this.imageWidth = 300
        this.imageHeight = 'auto'
      }
      else {
        this.imageHeight = 300
        this.imageWidth = 'auto'
      }
    },
    removeAsset(type) {
      let data = {};
      if (type == "background") {
        data.remove = "bgimg";
      } else if (type == "poster") {
        data.remove = "poster";
      }

      Service.Event.update({
        ...data,
        e: this.folder
      }).then(res => {
        if (res.success) {
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success"
          });
          this.popupActivo = false
        }
        this.event.bgimg = null;
        this.$vs.loading.close();
      });
    },
    onEditorBlur(quill) {},
    onEditorFocus(quill) {},
    onEditorReady(quill) {},
    onEditorChange({ quill, html, text }) {},
    successPosterUpload(res,) {
      Service.Event.get(this.folder)
        .then(res => {
          console.log('first')
          this.event = res.data.event;
          this.event.bgimg = res.data.event.bgimg
        })
        .catch(e => {
          /* this.$router.push("/pages/error-404").catch(() => {}); */
        })
        .finally(() => {
          this.changeImage = false
        });
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: "Poster upload success!"
      });
    },
    errorPosterUpload(res) {
      this.$vs.notify({
        color: "danger",
        title: "Upload Fail",
        text: "Poster upload fail!"
      });
    },
    changeBGColor(color) {
      this.assetForm.bgcolor = color.hex;
    },
    changeTextColor(color) {
      this.assetForm.txtcolor = color.hex;
    },
    submitAsset() {
      this.assetForm.e = this.folder;

      this.$vs.loading();

      Service.Event.update({
        ...this.basicForm,
        ...this.assetForm,
        pay_creditcard: (this.event.pay_creditcard === null && this.basicForm.pay_creditcard === 1) ? null: this.basicForm.pay_creditcard ,
        pay_transfer: (this.event.pay_transfer === null && this.basicForm.pay_transfer === 1) ? null: this.basicForm.pay_transfer ,
        fields_status: this.event.fields_status === null ? null: this.basicForm.fields_status
      })
        .then(res => {
          if (res.success) {
            this.$vs.notify({
              title: "Success",
              text: "Update complete.",
              color: "success"
            });
          }
          this.$vs.loading.close();
        })
        .catch(err => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
          this.$vs.loading.close();
        });
    },
    changeBgImg() {
      this.changeImage = true
      this.showBtn = true
    },
    getFont() {
      Service.Font.getFontList()
        .then(response => {
          this.fontList = response.items
        })
        .catch(() => {})
    },
    autoCompleteFunc(val) {},
    canceled() {
      this.$router.push(`/dash`)
    },
	chooseImage() {
		document.getElementById("file-upload-img").click()
	},
	onUploadImages() {
		this.bgUpdate = this.$refs.fileImage.files[0]
		this.event.bgimg = this.$refs.fileImage.files[0]
		const reader = new FileReader()
		reader.onloadend = async() => {
			this.event.bgimg = reader.result
			// this.bgUpdate = reader.result
			// this.posterUpdate = reader.resul
			this.updateBgImage(this.bgUpdate)
			this.setImageSize()
		}
		reader.readAsDataURL(this.$refs.fileImage.files[0])
		this.$refs.fileImage.value = null
	},
	updateBgImage(val) {
		const formData = new FormData()
		const dataKeyForms = Object.keys(this.basicForm);
		for (let index = 0; index < dataKeyForms.length; index++) {
			const key = dataKeyForms[index];
			const value = this.basicForm[key]  === null ? '': this.basicForm[key];
			formData.append(key, value);
		}
		formData.delete('daterange')
		formData.delete('selldaterange')
		formData.set('bgimg', this.bgUpdate)
		formData.set('daterange[0]', this.basicForm.daterange[0])
		formData.set('daterange[1]', this.basicForm.daterange[1])
		formData.set('selldaterange[0]', this.basicForm.selldaterange[0])
		formData.set('selldaterange[1]', this.basicForm.selldaterange[1])
    formData.set('pay_creditcard', (this.event.pay_creditcard === null && this.basicForm.pay_creditcard === 1) ? null: this.basicForm.pay_creditcard)
		formData.set('pay_transfer', (this.event.pay_transfer === null && this.basicForm.pay_transfer === 1) ? null: this.basicForm.pay_transfer)
    formData.set('fields_status', this.event.fields_status === null? null: this.basicForm.fields_status)

		const data = {
			e: this.folder
		}
		
		Service.Event.updateImage(formData, data)
			.then(() => {})
			.catch(err => {
				this.$vs.notify({
					title: "Oops!",
					text: "ERROR : Upload Backgroung Image",
					color: "danger"
				});
			});
	}
  },
  mounted() {
    this.getFont()
    this.setImageSize()
  }
};
</script>
<style lang="scss" scoped>
  .grid-button-upload {
    margin-top: 8px;
    display: grid;
    grid-template-columns: repeat(2, min-content);
    grid-gap: 10px;
  }
  .vs-button {
    font-size: 10px !important;
  }
  input[type="file"] {
	display: none !important;
}
.popup-confirm {
    & div {
      width: 100%;
      text-align: center;
    }
    & .wrap-button {
      display: grid;
      grid-template-columns: repeat(2, 25%);
      grid-gap: 8px;
      justify-content: flex-end;
      margin-top: 20px;
      
    }
  }
</style>
